export const PERMISSION_CREATE_REQUEST = 'PERMISSION_CREATE_REQUEST';
export const PERMISSION_CREATE_SUCCESS = 'PERMISSION_CREATE_SUCCESS';
export const PERMISSION_CREATE_FAIL = 'PERMISSION_CREATE_FAIL';
